module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-One.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-4"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("ONE")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic-italic",
    staticStyle: {
      "font-size": "1.78em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("H")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("er husband was dead")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Billie Bronson stood on the Cascade Mountain trail overlooking the steep drop down the side of the mountain. She took a deep breath and finally released the pain weighing heavy on her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pain. Anguish. Dread.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There, she’d finally admitted it. She’d been living under a cloud of dread during the last year of her marriage, nervous about Rick’s volatile moods and erratic behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tugged her fleece hat down to cover her ears. It felt as if the temperature had dropped ten degrees since she’d started out on her hike. But she had to finish this, had to visit the site where Rick had spent his last hours in her arms.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It had taken her a year to get to this place emotionally, the place where she accepted that what she needed most was closure. Closure and forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And I do forgive you,” she whispered, hugging herself. Forgiveness was a step toward grace, and it would help her heal.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Still, there were those occasional moments when she’d lie awake at night wondering if she could have done something to stop him from his downward spiral.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She glanced at the plateau below where Rick had shivered and groaned as she’d portioned out food to sustain them both until help had arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If only they hadn’t argued; if only he hadn’t stormed off and tripped, falling over the edge and hitting his head on a rock below. But you can’t rewind the past, no matter how much you want to.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A sudden flash of Quinn’s blue eyes and confident smile haunted her thoughts. No, she wouldn’t think about search-and-rescue volunteer Quinn Donovan, not today. He may have rescued her from the mountains and helped her get back on her feet by giving her a place to live, but he was another lost soul like Rick, running from his pain.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s good that I left,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d only seen Quinn sporadically since she’d started her new job at the Echo Mountain Resort. They’d agreed it was the best thing to do, the right thing, because they both had suspected she was leaning on him a little too much after he’d rescued her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was falling for him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But she wouldn’t make the mistake of thinking what they had was anything more than an emotional condition brought on by trauma. Billie was smarter than that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A sudden gust of wind whipped through the mountain pass. If she were so smart, she wouldn’t have gone hiking by herself. Although her friend Bree had offered to join her, letting go of the past wasn’t something you did with an audience. She interlaced her gloved fingers and closed her eyes. She said a prayer in an effort to completely let go.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lord, please help me make peace with Rick’s mistakes, with my own failures as a wife and—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Snap!")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She spun around and peered into the mass of trees to her left, but saw nothing, no wild animal or hiker. The hair pricked at the back of her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry to interrupt,” a deep male voice said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She spotted a man coming up the trail and relief washed over. It was a hiker, probably seeking solitude, like Billie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll just...” The man motioned that he’d trek past her and give her privacy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She stepped aside to let him pass. He was tall, about six feet, in his forties with brown hair combed back and a full beard. She noticed his lack of sensible gear. He wore a denim jacket over a purple University of Washington sweatshirt and sneakers instead of hiking boots. He wasn’t even wearing a hat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Billie assumed he was a tourist passing through town on his way to Vancouver. Travelers often stopped in the town of Echo Mountain for day hikes in the North Cascades.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Yes, he was definitely a tourist. A seasoned hiker would be better prepared with warmer clothing and a backpack.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With a polite smile he edged past her and followed the trail. She thought about suggesting he go back to town, warning him that he was ill prepared for a mountain hike, especially when the weather seemed to be turning cooler, but she didn’t want to seem judgmental. He hiked about ten feet and hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hang on,” he said and turned to her. “I know you. You’re that woman who was stranded out here with her husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Billie glanced at the ground, still ashamed that she’d been unable to save Rick’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That was you, wasn’t it?” he pressed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d been a local celebrity of sorts for weeks after the rescue. Everyone wanted to know how she’d survived, how she’d managed to keep Rick alive until the search-and-rescue team found them. All that attention made her uncomfortable, which is why she’d welcomed getting out of town and moving into Quinn’s coach house.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That must have been a traumatic experience, watching your husband die like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Actually, he died at the hospital,” she said, defending her failed efforts to treat his injuries.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Actually, I knew Rick,” he offered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You did?” She glanced up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure, he did some work for me. Seemed like a good guy. I would think you’d be too traumatized to return to this place.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, well, there’s something to be said for closure.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, I think you came out here for more than closure,” he said, his voice taking on a sharp edge.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stepped closer and goose bumps prickled her arms.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I think your husband left something behind and you came out here to get it,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Excuse me?” A shudder racked her body as she edged away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And it’s worth a lot of money,” he growled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Before she could take another step, he grabbed her arm in a viselike grip and shoved her against a tree. She cast a quick glance over her shoulder at the steep drop.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He leaned close. “Don’t run. I think we’d make a great team.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His hot, stale breath on her cheek shot panic through her body. With a guttural cry she jammed the heel of her hiking boot against the top of his foot, stunning him enough to loosen his grip. She spun around and took off down the trail.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where are you going?” he called after her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She had better gear, hiking experience and good instincts, but he had brute strength and what she assumed was a motivation to do her harm: retrieving something worth a lot of money. What had her husband gotten himself into?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I said...where are you going?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A firm hand clamped down on her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No!” She jerked away and lost her balance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arms flailing, she lunged forward, hoping to grab something to keep from careening down the mountainside. Instead, she caught air as she skidded over the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She cried out as she tumbled downward, her pack cushioning her fall. She willed her body to relax knowing that tensing would only increase her injuries.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Injuries? She should be more worried about her attacker, who was probably carrying a weapon in his denim jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She came to an abrupt stop and gasped for air. Tears rolled down her cheeks, not so much from the pain but from the realization she hadn’t come close to accomplishing what she’d hoped to in this lifetime. Like her husband, Billie had made her own share of bad decisions.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Like falling for Quinn Donovan.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Unbelievable. She was bruised and battered, possibly going to die so close to where Rick had suffered life-threatening injuries, yet she was thinking about Quinn, his warm eyes that grayed when he was upset, eyes that sparkled bright blue when confident or pleased. Blue, like the sky peeking through the western hemlock and Douglas fir trees towering above.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Stay conscious,” she ordered herself. She had enough presence of mind to reach into her pocket and activate the personal locator beacon that would alert her friend Bree that she was in trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A gray fog drifted through the trees like a curtain, similar to the one drifting across her mind, muddling her thoughts, her prayers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Please, God...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She struggled to focus, to hold on to a sense of time and place. She couldn’t pass out, not yet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In her last moments of consciousness, maybe even the last moments of her life, she struggled to pray, but the prayer was not for herself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Help...Quinn,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And the world faded to black.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("Quinn had sent Billie away months ago for her own good, yet she lay at the bottom of a mountain trail so very still and motionless...and dead?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No, Quinn would not accept that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going down,” he said, gripping the rope with both hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe you should wait for the rest of the team,” Artie Meyers suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn and Artie were the first to arrive. Not a surprise since it was the middle of the day when most Snoquamish County Search and Rescue volunteers were at work. More would be coming soon, but as one of the first two at the scene, Quinn took the field command position. That’s about as far as normal protocol would matter to Quinn today. He wouldn’t get bogged down by procedure, not with Billie’s life at stake.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll radio when I get to her.” Quinn nodded at the middle-age man and started his descent.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn had to pretend this was a routine rescue, that Billie wasn’t lying broken and bleeding on the plateau below. He had to act as if the injured party wasn’t the woman he’d rescued over a year ago and taken into his life to help her get back on her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The only woman who’d touched a spot inside of Quinn that he thought had been destroyed by a brutal childhood, war and loss.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shifted his boots against the mountainside and steadied his descent, trying to rein in his panic. He needed to get control of his thoughts, needed to think of Billie as a random, injured hiker.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The text he’d received half an hour ago flashed across his mind: "), _c('span', {
    staticClass: "ef",
    staticStyle: {
      "font-size": "0.91em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Female victim, thirties, fell while hiking.")]), _vm._v(" He hadn’t been sure he’d be able to leave his business meeting to join the team.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then Aiden, Quinn’s friend and Billie’s boss, sent another text: the victim was Billie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Billie knew better than to take off into the mountains without hiking buddies. The rule was at least three in a group so that if someone was injured, one hiker could stay with the immobilized party while the third person went for help.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Billie was smart and sensible, yet she’d fallen off a trail close to where she and her husband had been stranded for days, and her husband had sustained a blow to the head from a fall that ultimately took his life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Was this some kind of penance? Return to the scene where she’d been unable to save her husband in order to drive home her personal failure?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The rope slipped between his gloved fingers and he tightened his grip. He had to focus on helping the victim and stop analyzing his friend’s motivations for coming out here alone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A friend? Is that what she was? The frantic beating of his heart when he’d read Aiden’s text indicated otherwise. Quinn couldn’t remember driving to the trailhead, or specifics of the conversation he’d had with Aiden. Everything was a blur except the rope between his fingers and the chill seeping through his jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And, of course, the thought of Billie lying on a mountain plateau bruised and broken, and no doubt terrified.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But alive. God, please let her be alive.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Back up, buddy")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God doesn’t listen to guys like you, remember?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He must have dropped a good fifty feet before he touched down. Corralling his panic at what he’d see when he examined Billie up close, Quinn took a deep breath and kneeled beside her still body.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Billie?” he said, brushing copper-streaked dark brown hair off her cheek. “Can you hear me, sweetheart?” The endearment slipped out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He pulled off his glove with his teeth and pressed his fingers against her neck. He realized he held his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A strong and steady pulse beat against his fingertips. A sigh of relief escaped his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you,” he whispered, not sure if he was thanking God for watching over her or thanking Billie for her incredible strength.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He cleared his throat and pressed the button on his radio. “The victim’s alive. Send a litter down ASAP, over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Roger that. How many team members will you need to secure her to the litter and lift her up, over?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a small area. I can manage it by myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Roger.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn took off his pack and pulled out a thermal blanket. He covered Billie, tucking the blanket snugly around her body. Glancing at the sky, he hoped the weather would hold until they got her out of here. They’d strap her securely to the litter and raise her to the trail. Her injuries would determine how they’d get her out of here, either by helo or ambulance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A moan drew his attention to Billie. She opened her normally colorful eyes—usually rich with hues of amber, green and warm brown—now a dull dark gray.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He forced a smile. “We have to stop meeting like this, Wilhelma.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Quinn? What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She must be in pain if she wasn’t scolding him for calling her by her full name, a name she disliked. “I’m on speed dial for damsels in distress, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, right.” She closed her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He couldn’t admit the truth: that after Billie got the job at one of Quinn’s properties, Quinn asked his friend and resort manager Aiden McBride to keep Quinn in the loop. In other words, let Quinn know how Billie was doing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn couldn’t help himself. He’d felt a connection to her, a connection he chose to ignore because he excelled at hurting the people closest to him. He’d already hurt Billie in so many ways, ways she didn’t even know about.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Even though Quinn kept his distance from Billie, he’d appreciated the updates from Aiden: Billie excelled at her job as a restaurant hostess, was making friends in the community and was active in the local church. She had blossomed after leaving Quinn’s life. He was glad, even if some days he missed her so much it physically hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Injuries?” he asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Head mostly. I’m okay.” She tried to sit up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lie down. You don’t want me to get in trouble for not following protocol.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fine.” She lowered herself to the ground. “How did you get here so quickly?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was in a business meeting nearby. Aiden texted me after Bree got the alert from your personal locator beacon. She would have been here, but she was stuck up north on business. Sheriff’s office also got a call from another hiker who saw you fall.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Another hiker.” She opened her eyes, panicked. “Did he see the guy who attacked me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Every muscle in Quinn’s body tensed. “Someone attacked you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He grabbed me and I pulled away and lost my footing. He was wearing a denim jacket and gym shoes and he asked me about Rick, and...and...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her breathing sped up and her cheeks flushed. Quinn guessed her blood pressure was in the triple digits.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shh.” He placed an open palm against her cheek. “We’ll deal with that later. Right now you’ve got to lie still and relax.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With a few shallow breaths she closed her eyes and leaned into his touch. The feel of her skin against his hand spread warmth up his arm. No other woman had this kind of effect on him. A part of Quinn ached to explore the dynamic further, but he’d never do that to Billie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She suddenly turned her head, breaking the connection.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s wrong?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Try again.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She opened her eyes, now tinted with amber and golden hues. He relaxed a little.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t believe me about the man on the trail.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I do believe you, but I’d like to deal with one thing at a time. I know you’re the master multitasker, but I’ve got a guy’s brain, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He thought she smiled. He hoped she smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ll get you to the hospital, then we’ll deal with the mystery hiker,” Quinn said. Although he hadn’t a clue how he was going to control himself if he ever came face-to-face with the guy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m afraid,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s not here. It’s just me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn assumed she wasn’t afraid of him, yet he wouldn’t blame her if she were.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sighed. “Quinn, if my injuries are worse than they seem and I don’t—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Stop it,” Quinn ordered, because if she didn’t make it...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wouldn’t be able to survive that kind of pain.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But, Quinn,” she started, “you should know that the hiker accused me of coming out here to get something Rick left behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She obviously couldn’t stop thinking about the threat so he encouraged her to continue. “Left something? Like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I have no idea. Something worth a lot of money apparently.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" you come out here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was hiking.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Alone?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I needed closure.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn leaned back on his heels. Closure was something he’d wished for with so many people in his life, especially his mom, who died when he was a kid.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He glanced at the ridge above, then at Billie. “So, was it worth it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re making fun of me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I’m not, although I was hoping to make you smile.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This isn’t funny. The guy said we’d make a good team. He was creepy and his breath smelled awful and he shoved me against a tree, and I thought, I thought—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shh.” He touched her shoulder. “He’s gone. No one’s going to hurt you while I’m here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sighed and looked away. They both knew that wasn’t true since Quinn could hurt her worst of all. Not physically, but in every other way that mattered. He couldn’t give Billie the sincere love and devotion she deserved. He was incapable of such feelings, incapable of opening his heart to a woman. After everything Billie had been through, she deserved a loving man with integrity.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hate this,” she muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The pain?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I meant I’m sorry to be inconveniencing everyone, making them drop whatever they’re doing to come out and rescue me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not an inconvenience. They live for this stuff—you know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, I’m embarrassed that I need their help.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There’s nothing wrong with accepting help, Billie.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She chuckled and clutched her wrist to her chest, pinching her eyes shut.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s so funny?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You giving me a pep talk about accepting help from others.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was right, of course. Quinn was not the type to seek counsel or ask anyone for help. A few seconds passed and he wondered if she’d lost consciousness. He was about to speak her name.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you,” she suddenly whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For saving me...again.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I haven’t saved you yet,” Quinn said, trying to lighten the mood.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She opened her eyes and he could tell she struggled to crack a smile. She was in pain and it was driving him nuts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He yanked the radio off his belt. “Artie, where’s that litter, over?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The guys just got here, over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn turned to Billie. “Saving you is getting to be a full-time job, Ms. Bronson.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t worry, this will be the last time,” she said, her tone flat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, I was—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Kidding, I know.” She cracked a sad smile. “But I wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That sounded awfully final, as if she no longer wanted him helping her, being there for her. “I don’t mind playing hero where you’re concerned.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe I do. Maybe I mind depending on you because it makes me feel weak and naive. You won’t be there forever, or even tomorrow, or—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, calm down.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll be calm when you get me out of here,” she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wondered if a head injury was causing the edge to her normally affable personality. She suddenly didn’t seem like herself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not taking his eyes off her, Quinn stood and reached for the radio to see what was taking so long.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Quinn!” she cried, her eyes rounding with fear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He glanced up and caught sight of something careening toward them. There was no way to dodge what looked like a large piece of equipment without leaving Billie exposed, making her the prime target.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Close your eyes!” He instinctively threw himself over her body like a human shield and clenched his jaw in anticipation of the impending blow.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-2"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-716d0110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterOne.vue
// module id = 81
// module chunks = 0